import React, { createContext, useState } from 'react'

import { serverSideQuery, useQuery } from '@/api'
import { DEFAULT_CONTEXT_VALUES, PERFORMERS_ENDPOINT } from '@/constants'

import {
    breadcrumbSelector,
    getCategory,
    getSubCategoryAndCategoryId,
    pageTitleSelector,
    performerPageURLSelector,
    productionListTitleSelector,
    relatedEventsParamsSelector,
    singleRecordSelector,
} from './selectors'
import type { PerformerContextType, PerformerDataType, PerformerProviderProps } from './types'

const PerformerContext = createContext<PerformerContextType>(DEFAULT_CONTEXT_VALUES)
const { Provider } = PerformerContext

export const PerformerProvider: React.FC<PerformerProviderProps> = ({
    children,
    initialProps,
    initialFetchDisabled,
    initialParams,
}) => {
    const [params, setParams] = useState(initialParams)
    const { data, error, fetching } = useQuery<PerformerDataType>({
        endpoint: PERFORMERS_ENDPOINT,
        params,
        initialFetchDisabled,
        initialData: initialProps?.data,
    })

    const state = { data, error, fetching, ...initialProps }

    return (
        <Provider
            value={{
                state,
                dispatch: {
                    read: (params) => {
                        setParams(params)
                    },
                },
                selectors: [
                    singleRecordSelector(state),
                    breadcrumbSelector(state),
                    pageTitleSelector(state),
                    getCategory(state),
                    performerPageURLSelector(state),
                    productionListTitleSelector(state),
                    getSubCategoryAndCategoryId(state),
                    relatedEventsParamsSelector(state),
                ],
            }}
        >
            {children}
        </Provider>
    )
}

export const serverSideRead = serverSideQuery<PerformerDataType>(PERFORMERS_ENDPOINT)
export default PerformerContext
